import { makeObservable, observable } from "mobx"

import { BaseModel } from "./base.model"

import type { ReactElement } from "react"

export class ModalModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable isOpen = false
  @observable isDarkTheme = false
  @observable isNewType = false
  @observable content = null as ReactElement | null

  open = (
    content: ReactElement,
    isDarkTheme?: boolean,
    isNewType?: boolean,
  ) => {
    this.applyData({
      isOpen: true,
      content,
      isDarkTheme: Boolean(isDarkTheme),
      isNewType: Boolean(isNewType),
    })
  }

  close = () => {
    this.applyData({
      isOpen: false,
      content: null,
      isDarkTheme: false,
      isNewType: false,
    })
  }
}
